<template>
    <div class="spinning-loader" :style="rootStyles">
        <svg xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                preserveAspectRatio="none"
                tabindex="-1"
                class="spinning-loader--svg"
                :viewBox="svgViewBox">
            <path class="spinning-loader--svg-path"
                    :d="svgPathContent"
                    :style="svgPathStyles"
                    ref="svgPath"/>
        </svg>
    </div>
</template>

<script>
    import { isMountedMixin } from '@dreipol/vue-ui/src/mixins';

    export default {
        mixins: [
            isMountedMixin,
        ],
        props: {
            size: {
                type: Number,
                default: 32,
            },
            radius: {
                type: Number,
                default: 12,
            },
            strokeWidth: {
                type: Number,
                default: 2,
            },
        },
        data() {
            return {
                handle: 0,
            };
        },
        computed: {
            center() {
                return this.size / 2;
            },
            startPoint() {
                return this.center - this.radius + (this.strokeWidth / 2);
            },
            endPoint() {
                return this.center + this.radius - (this.strokeWidth / 2);
            },
            svgViewBox() {
                const { size } = this;
                return `0 0 ${ size } ${ size }`;
            },
            svgPathContent() {
                const { radius, center, startPoint, endPoint } = this;
                const r = radius - (this.strokeWidth / 2);

                return `
                    M${ center },${ startPoint }
                    A ${ r },${ r } 0 0,1 ${ endPoint },${ center }
                    A ${ r },${ r } 0 0,1 ${ center },${ endPoint }
                    A ${ r },${ r } 0 0,1  ${ startPoint },${ center }
                    A ${ r },${ r } 0 0,1 ${ center }, ${ startPoint }
                    z
                `;
            },
            rootStyles() {
                return {
                    width: `${ this.size }px`,
                    height: `${ this.size }px`,
                };
            },
            svgPathStyles() {
                if (!this.isMounted) {
                    return {};
                }

                const { svgPath } = this.$refs;
                const length = svgPath.getTotalLength();

                return {
                    strokeWidth: this.strokeWidth,
                    strokeDasharray: `${ length } ${ length }`,
                    strokeDashoffset: length,
                };
            },
        },
        methods: {
            draw(currentFrame, totalFrames, length) {
                const { svgPath } = this.$refs;
                var progress = currentFrame / totalFrames % 2;

                svgPath.style.strokeDashoffset = Math.floor(length * (1 - progress));

                this.handle = window.requestAnimationFrame(() => {
                    this.draw(currentFrame + 1, totalFrames, length);
                });
            },
        },
        mounted() {
            this.draw(0, 60, this.$refs.svgPath.getTotalLength());
        },
        beforeDestroy() {
            window.cancelAnimationFrame(this.handle);
        },
    };
</script>
